/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerAllergensInner } from './GetProducts200ResponseItemsInnerAllergensInner';
import {
    GetProducts200ResponseItemsInnerAllergensInnerFromJSON,
    GetProducts200ResponseItemsInnerAllergensInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerAllergensInnerToJSON,
    GetProducts200ResponseItemsInnerAllergensInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerAllergensInner';

/**
 * 
 * @export
 * @interface GetModifiers200ResponseItemsInner
 */
export interface GetModifiers200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifiers200ResponseItemsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetModifiers200ResponseItemsInner
     */
    priceImpact: number;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    organizationId: string;
    /**
     * 
     * @type {number}
     * @memberof GetModifiers200ResponseItemsInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifiers200ResponseItemsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    kitchenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifiers200ResponseItemsInner
     */
    shortName?: string | null;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerAllergensInner>}
     * @memberof GetModifiers200ResponseItemsInner
     */
    allergens?: Array<GetProducts200ResponseItemsInnerAllergensInner>;
}

/**
 * Check if a given object implements the GetModifiers200ResponseItemsInner interface.
 */
export function instanceOfGetModifiers200ResponseItemsInner(value: object): value is GetModifiers200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('priceImpact' in value) || value['priceImpact'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function GetModifiers200ResponseItemsInnerFromJSON(json: any): GetModifiers200ResponseItemsInner {
    return GetModifiers200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetModifiers200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifiers200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'priceImpact': json['priceImpact'],
        'organizationId': json['organizationId'],
        'position': json['position'],
        'deleted': json['deleted'],
        'source': json['source'] == null ? undefined : json['source'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'color': json['color'] == null ? undefined : json['color'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerFromJSON)),
    };
}

export function GetModifiers200ResponseItemsInnerToJSON(json: any): GetModifiers200ResponseItemsInner {
    return GetModifiers200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetModifiers200ResponseItemsInnerToJSONTyped(value?: GetModifiers200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'priceImpact': value['priceImpact'],
        'organizationId': value['organizationId'],
        'position': value['position'],
        'deleted': value['deleted'],
        'source': value['source'],
        'externalId': value['externalId'],
        'color': value['color'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerToJSON)),
    };
}

